import { ReactSVG } from "react-svg";
import styles from "./why_attend.module.scss";

const data = [
  {
    iconSrc: "/assets/icons/attend-card-one.svg",
    title: "Meet Top University Representatives",
    description:
      " Interact one on one with top university representatives and know about the campus and their course details, application process, and future career paths after the course",
  },
  {
    iconSrc: "/assets/icons/attend-card-two.svg",
    title: "Application Guidance",
    description:
      "Get application assistance and guidance by top university representatives and Leverage Edu experts who will handhold you at every step",
  },
  {
    iconSrc: "/assets/icons/attend-card-three.svg",
    title: "Scholarship Guidance",
    description:
      "Find out how to qualify for generous scholarships and educational loans, in exclusive webinars and presentations",
  },
  {
    iconSrc: "/assets/icons/attend-card-four.svg",
    title: "Get On-Spot Offers",
    description:
      "Apply with one click inside the booth and secure on-spot offers from top universities",
  },
];

const VFairWhyAttend = () => {
  return (
    <section className={styles.why_attend_section}>
      <div className="container">
        <div className={styles.why_attend_text_wrapper}>
          <h2 className="mb-8">
            Why <span className="color-orange"> Attend?</span>
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {data?.map((item, i) => {
            return (
              <div key={i} className={`${styles.why_attend_card}`}>
                <ReactSVG src={item?.iconSrc} />
                <h3>{item?.title}</h3>
                <div>{item?.description}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default VFairWhyAttend;
